import { FunctionComponent, memo, useContext } from "react";
import { IProps } from "./tag-actions-menu.types";
import { EllipsisMenu } from "@edgetier/client-components";
import DeleteTag from "./delete-tag";
import EditTag from "./edit-tag";
import ExploreLink from "components-for/navigation/explore-link";
import Page from "constants/page";
import { getDefaultRouteUrls } from "utilities/get-default-route-urls";
import TagsListContext from "pages/tag-phrase-triggers/tags-list/tags-list-context/tags-list-context";
import "./tag-actions-menu.scss";

/**
 * A menu to edit or delete a tag.
 * @param props.tag   The tag name.
 * @param props.tagId The ID of the tag.
 */
const TagActionsMenu: FunctionComponent<IProps> = ({ isButton = false, placement = "left-center", tag, tagId }) => {
    const { parameters } = getDefaultRouteUrls()[Page.Explore];
    const { showExploreAction } = useContext(TagsListContext);
    return (
        <div className="tag-actions-menu" onClick={(event) => event.stopPropagation()}>
            <EllipsisMenu
                isButton={isButton}
                menuLabel={isButton ? "Options" : undefined}
                placement={placement}
                overflowContainer
            >
                <DeleteTag tag={tag} tagId={tagId} />
                <EditTag tagId={tagId} />
                {showExploreAction && <ExploreLink parameters={{ ...parameters, tagId: [tagId] }} />}
            </EllipsisMenu>
        </div>
    );
};

export default memo(TagActionsMenu);
